import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function AdvertiseConfirm() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/sponsors/order/${id}`).then((r) => setO(r.data)).catch((e) => setErr(errMsg(e)));
  }, [id]);
  if (err) return <div className="page"><p className="panel p-6 text-zinc-300">{err}</p></div>;
  if (!o) return <div className="page flex justify-center py-20"><Loader2 className="animate-spin text-[#fde68a]" /></div>;
  const paid = o.status === "paid";
  return (
    <div className="page max-w-2xl">
      <div data-testid="advertise-confirmation" className="panel p-8">
        <CheckCircle2 className="mb-3 text-emerald-400" size={34} />
        <h1 className="font-heading text-5xl text-white">{paid ? "Payment received!" : "Request received!"}</h1>
        <dl className="mt-6 grid grid-cols-2 gap-4 text-sm">
          <div><dt className="text-zinc-500">Business</dt><dd className="font-semibold text-white">{o.business_name}</dd></div>
          <div><dt className="text-zinc-500">State</dt><dd className="font-semibold text-white">{o.state}</dd></div>
          <div><dt className="text-zinc-500">Weeks</dt><dd className="font-semibold text-white">{o.weeks}</dd></div>
          <div><dt className="text-zinc-500">Total</dt><dd data-testid="confirm-total" className="font-semibold text-[#fde68a]">${o.amount}</dd></div>
        </dl>
        <p className="mt-6 text-zinc-300">
          {paid ? "We'll contact you to get a photo for your ad." : "Online card payment is coming soon. We'll contact you by email or phone to take payment and get a photo for your ad."}
        </p>
        <p className="mt-2 text-xs text-zinc-500">Reference: {o.id.slice(0, 8).toUpperCase()}</p>
        <Link to="/" className="mt-6 inline-block font-semibold text-[#fde68a] hover:underline">Back to happy hours →</Link>
      </div>
    </div>
  );
}
